<template lang="pug">

include ../../../pug/mixins/index

+b-context('category')

  +e.block
    +e.name(:class='nameClass', v-text='i18n.reactions[type]')
    +e.wrap-slider(:class!=`{ 'is-active': active }`)
      +e.close.--global.icon-close3(@click.prevent='active=false')
      +e.SLIDER.slider(:options!=`{
        prevButton: '.category__nav--prev',
        nextButton: '.category__nav--next',
      }`)
        +e.SWIPER-SLIDE.slide(v-for='item in items', :key='item.product.id')
          +e.close.--desktop.icon-close3(@click.prevent='confirmOpen(item)')
          .calendar__title(v-text='item.product.name')
          .calendar__img.img: img(:src='item.product.small_image', style='max-height: 55px', @click.prevent='active=true')
          +e.close.--mobile(@click.prevent='confirmOpen(item)') Удалить
        +e.nav.--prev.icon-left(slot='button-next', v-show='items.length > 0')
        +e.nav.--next.icon-right(slot='button-prev', v-show='items.length > 0')

    custom-modal(:title='confirmTitle', ref='confirm', :dismissible='false', @click.prevent.stop='')
      .modal__picture.img
        img(:src="removable.large_image || removable.small_image")
        .modal__icon(:class='confirmIcon')
      template(slot="footer")
        .modal__part
          button.calendar__link.modal__link2(@click.prevent='confirmSucceed()', v-text='i18n.yes')
          button.calendar__link.modal__link2(@click.prevent='confirmClose()', v-text='i18n.no')

</template>

<script>

import Translatable from '@shared/mixins/translatable'

export default {
  props: {
    title: { type: String },
    type: { type: String, required: true },
    items: { type: Array, required: true },
  },

  mixins: [Translatable],

  data() { return {
    active: false,
    removable: {},
    confirmTitle: '',
    confirmIcon: '',
  } },

  computed: {
    nameClass() {
      return { [`category__name--${this.type}`]: true }
    }
  },

  methods: {
    confirmOpen(item) {
      let action = {
        liked: 'like',
        disliked: 'dislike',
        allergic: 'allergic'
      }[this.type]
      let actionId = {
        like: 1,
        dislike: 2,
        allergic: 3
      }[action]

      this.confirmIcon = `modal__icon--${actionId}`
      this.confirmTitle = this.i18n.reactionAction[
        `${action}_delete`
      ]

      this.removable = item.product
      this.$refs.confirm.open()
      this.confirmSucceed = x => this.removeItem(item)
    },

    confirmClose() {
      this.$refs.confirm.close()
    },

    confirmSucceed() {},

    removeItem(item) {
      this.confirmClose()
      this.active = false
      this.$emit('remove', { type: this.type, item })
    },

    getItemPreviewStyle(item) {
      return {
        'background-image': `url('${item.preview}')`
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/js/calendar/components/reaction-slider.vue